import React, { useEffect, useState } from "react";
import moment from "moment";
import URL from "../../../../Main/url";
import CurrencyWord from "../../../../Componets/Currencywords";

const A4Invoice = React.forwardRef((props, ref) => {
  const { values } = props;

  // Function to capitalize first letter of each word
  const capitalizeWords = (str) => {
    if (!str) return "";
    return str.replace(/\b\w/g, char => char.toUpperCase());
  };

  const injectScopedStyles = () => {
    const style = document.createElement("style");
    style.innerHTML = `
      @page {
        size: A4;
        margin: 6% 6% 16% 6%;
        @bottom-left {
          font-size: 12px;
         
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          left: 6%;
        }
        @bottom-right {
          font-size: 12px;
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          right: 6%;
        }
      }
  
      @media print {
        .a4-invoice-footer {
          font-size: 12px;
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          left: 6%;
        }
  
        .a4-invoice-footer-right {
          font-size: 12px;
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          right: 6%;
        }
      }
    `;
    document.head.appendChild(style);
  };

  useEffect(() => {
    if (values?.branch?.name) {
      injectScopedStyles();
    }
  }, [values?.branch?.name]);

  return (
    <div className="px-24">
      <div className="" ref={ref}>
        <div>
          <div className="flex justify-between items-start pb-4">
            <div className="text-black-900 text-[0.65rem]">
              <div className="text-bold text-md">{capitalizeWords(values?.branch?.name)}</div>
              <div className="text-medium text-xs">
                Email&nbsp;:&nbsp;
                {values?.branch?.email ? values?.branch?.email + ", " : ""}
                &nbsp;
              </div>
              <div className="text-medium text-xs">
                Phone&nbsp;:&nbsp;
                {values?.branch?.phone ? values?.branch?.phone : ""}
                &nbsp;
              </div>
              <div className="text-xs">
                {values?.branch?.area ? values?.branch?.area + ", " : ""}
                {values?.branch?.city ? values?.branch?.city + ", " : ""}
                {values?.branch?.country ? values?.branch?.country : ""}
              </div>
              <div className="text-xs">
                VATIN&nbsp;:&nbsp;
                {values?.branch?.tax ? values?.branch?.tax : "N/A"}
              </div>
            </div>
            {values?.branch?.image ? (
              <div className="flex justify-center flex-col items-center">
                <div className="text-xl pb-2">
                  <img
                    className="w-[50px] h-[50px]"
                    src={`${URL}/uploads${values?.branch?.image}`}
                    alt="Branch Logo"
                  />
                </div>
                <div className="text-bold text-lg">{capitalizeWords(values?.branch?.name)}</div>
              </div>
            ) : (
              <div className="flex justify-center flex-col items-center">
                <div
                  className="w-[50px] h-[50px] rounded-md bg-gray-300 text-black flex items-center justify-center text-xl font-semibold"
                >
                  {values?.branch?.name
                    ? values.branch.name.charAt(0).toUpperCase()
                    : "N"}
                </div>
                <div className="text-bold text-lg">{capitalizeWords(values?.branch?.name)}</div>
              </div>
            )}

          </div>

          <hr className="my-2 border-t-black-900 border-black" />
          <div className="text-medium text-md text-center py-1">TAX INVOICE</div>
          <hr className="my-2 border-t-black-900 border-black" />

          <div className="border border-gray-300 rounded-lg p-4 mb-4 shadow-sm">
            <div className="flex justify-between">
              <div>
                <div className="font-semibold text-[0.70rem] mb-2">Customer Name</div>
                <div className="text-[0.65rem] space-y-1">

                  <div className="font-medium">
                    {values?.customer?.name
                      ? values?.customer?.name
                      : "Walk-in-customer"}
                  </div>

                  {values?.customer?.phone && (
                    <div>
                      <span className="font-semibold">Phone :</span>{" "}
                      {values?.customer?.phone}
                    </div>
                  )}

                  {values?.customer?.email && (
                    <div>
                      <span className="font-semibold">Email :</span>{" "}
                      {values?.customer?.email}
                    </div>
                  )}

                  <div>
                    {values?.customer?.city ? values?.customer?.city + ", " : ""}
                    {values?.customer?.state}
                  </div>

                  <div>{values?.customer?.country}</div>

                  {values?.customer?.tax && (
                    <div>
                      <span className="font-semibold">VATIN :</span>{" "}
                      {values?.customer?.tax}
                    </div>
                  )}
                </div>
              </div>


              <div>
                <div className="text-[0.65rem] space-y-1">
                  <div className="flex">
                    <div className="w-24 text-bold">Invoice No</div>
                    <div className="px-2">:</div>
                    <div className="text-right">#INV-{values?.number}</div>
                  </div>
                  <div className="flex">
                    <div className="w-24 text-bold">Invoice Type</div>
                    <div className="px-2">:</div>
                    <div className="text-right">
                      {values?.payment_status == 2
                        ? values?.payments
                          ?.map((v, i) => (i > 0 ? ", " : "") + v?.name)
                          .join("")
                        : "CREDIT"}
                    </div>
                  </div>
                  <div className="flex">
                    <div className="w-24 text-bold">Date</div>
                    <div className="px-2">:</div>
                    <div className="text-right">
                      {moment?.(values?.date)?.format?.("DD-MM-YYYY")}
                    </div>
                  </div>
                  {values?.due_date ? (
                    <div className="flex">
                      <div className="w-24">Due Date</div>
                      <div className="px-2">:</div>
                      <div className="text-right">
                        {moment?.(values?.due_date)?.format?.("DD-MM-YYYY")}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {values?.lpo_number ? (
                    <div className="flex">
                      <div className="w-24">Lpo No</div>
                      <div className="px-2">:</div>
                      <div className="text-right">{values?.lpo_number}</div>
                    </div>
                  ) : (
                    ""
                  )}
                  {values?.lpo_date ? (
                    <div className="flex">
                      <div className="w-24">Lpo Date</div>
                      <div className="px-2">:</div>
                      <div className="text-right">
                        {moment?.(values?.lpo_date)?.format?.("DD-MM-YYYY")}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {values?.salesman?.name ? (
                    <div className="flex">
                      <div className="w-24">Salesman</div>
                      <div className="px-2">:</div>
                      <div className="text-right">{values?.salesman?.name}</div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="min-h-[300px]">
            <table className="w-full border-separate border-spacing-0 rounded-lg overflow-hidden border border-gray-300">

              <thead>
                <tr className="bg-gray-100">
                  <th className="text-[0.60rem] text-left py-2 pl-3 border-b border-gray-300 rounded-tl-lg">
                    S.NO
                  </th>
                  <th className="text-[0.60rem] text-left p-1 border-b border-gray-300">
                    DESCRIPTION
                  </th>
                  <th className="text-[0.60rem] text-left p-1 border-b border-gray-300">
                    BATCH / EXPIRY
                  </th>
                  <th className="text-[0.60rem] text-left p-1 border-b border-gray-300">
                    RET.PRICE
                  </th>

                  <th className="text-[0.60rem] text-left p-1 border-b border-gray-300">
                    QTY
                  </th>
                  <th className="text-[0.60rem] text-left p-1 border-b border-gray-300">
                    FOC
                  </th>
                  <th className="text-[0.60rem] text-left p-1 border-b border-gray-300">
                    W.S PRICE
                  </th>
                  <th className="text-[0.60rem] text-left p-1 border-b border-gray-300">
                    DISC
                  </th>
                  <th className="text-[0.60rem] text-left p-1 border-b border-gray-300">
                    <div className="text-bold">AMOUNT</div>
                    <div className="text-[0.50rem] lowercase">(Before VAT)</div>
                  </th>
                  <th className="text-[0.60rem] text-left p-1 border-b border-gray-300">
                    VAT%
                  </th>
                  <th className="text-[0.60rem] text-left p-1 border-b border-gray-300">
                    VAT Amount
                  </th>
                  <th className="text-[0.60rem] text-left pr-2 border-b border-gray-300 rounded-tr-lg">
                    <div className="text-bold">TOTAL</div>
                    <div className="text-[0.50rem] lowercase">(With VAT)</div>
                  </th>
                </tr>
              </thead>

              <tbody className="text-sm">
                {values?.details?.map((value, index) => {
                  const isLastDataRow = index === values.details.length - 1;
                  const isLastOverallRow =
                    values.details.length >= 8
                      ? isLastDataRow
                      : false;


                  return (
                    <tr
                      key={index}
                      className="hover:bg-gray-50"
                    >
                      <td
                        className={`text-[0.60rem] text-left p-1 pl-3 ${isLastOverallRow ? "rounded-bl-lg" : ""
                          }`}
                      >
                        {index + 1}
                      </td>

                      <td className="text-[0.60rem] text-left p-1">
                        <div>{value?.name}</div>
                      </td>

                      <td className="text-[0.60rem] text-left p-1">
                        <div className="text-[0.60rem] ">
                          {value?.description?.number}
                        </div>
                        <div className="text-[0.60rem] text-left">
                          {value?.expiry_date
                            ? `${moment(value?.expiry_date).format("DD/MM/YYYY")}`
                            : ""}
                        </div>
                      </td>

                      <td className="text-left text-[0.60rem] p-1">
                        {value?.description?.sale_price?.toFixed(3)}
                      </td>


                      <td className="text-left text-[0.60rem] p-1">
                        {value?.quantity}
                      </td>
                      <td className="text-left text-[0.60rem] p-1">
                        {value?.free || 0}
                      </td>
                      <td className="text-left text-[0.60rem] p-1">
                        {value?.sale_price?.toFixed(3)}
                      </td>

                      <td className="text-left text-[0.60rem] p-1">
                        <div className="leading-[1rem]">{value?.discount_percentage}%</div>
                        <div className="text-gray-500 leading-[1rem]">
                          {value?.discount_price?.toFixed?.(3)}
                        </div>
                      </td>


                      <td
                        className={`text-left text-[0.60rem] p-1 pr-2 ${isLastOverallRow ? "rounded-br-lg" : ""
                          }`}
                      >
                        {(value?.quantity * value?.sale_price).toFixed(3)}
                      </td>
                      <td className="text-left text-[0.60rem] p-1">
                        <div>{value?.tax}%</div>

                      </td>

                      <td className="text-left text-[0.60rem] p-1">
                        <div className="text-gray-500">
                          {value?.tax_amount?.toFixed(3)}
                        </div>
                      </td>

                      <td
                        className={`text-left text-[0.60rem] p-1 pr-2 ${isLastOverallRow ? "rounded-br-lg" : ""
                          }`}
                      >
                        {value?.total?.toFixed(3)}
                      </td>
                    </tr>
                  );
                })}

                {(!values?.details || values.details.length < 8) &&
                  Array.from({
                    length: 8 - (values?.details?.length || 0),
                  }).map((_, index, arr) => {
                    const isLastEmptyRow = index === arr.length - 1;
                    const lastRowRounded =
                      values?.details?.length === 0
                        ? index === arr.length - 1
                        : values?.details?.length + index === 7;

                    return (
                      <tr key={`empty-${index}`} className="hover:bg-gray-50">
                        <td
                          className={`text-[0.60rem] p-2 pl-3 ${lastRowRounded ? "rounded-bl-lg" : ""
                            }`}
                        >
                          &nbsp;
                        </td>
                        <td className="p-2">&nbsp;</td>
                        <td className="p-2">&nbsp;</td>
                        <td className="p-2">&nbsp;</td>
                        <td className="p-2">&nbsp;</td>
                        <td className="p-2">&nbsp;</td>
                        <td className="p-2">&nbsp;</td>
                        <td className="p-2">&nbsp;</td>
                        <td className="p-2">&nbsp;</td>
                        <td className="p-2">&nbsp;</td>
                        <td className="p-2">&nbsp;</td>

                        <td
                          className={`text-right text-[0.60rem] p-1 pr-2 ${lastRowRounded ? "rounded-br-lg" : ""
                            }`}
                        >
                          &nbsp;
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>


          <div className="border border-gray-300 rounded-lg p-4 mb-4 mt-4 shadow-sm">
            <div className="flex justify-between">
              <div className="text-[0.65rem] w-1/2">
                <div className="font-semibold mb-2 text-[0.70rem]">
                  Total in words&nbsp;:&nbsp;
                  <span className="font-normal">
                    <CurrencyWord amount={values?.total?.toFixed(3)} />
                  </span>
                </div>
              </div>

              <div className="text-[0.65rem] w-1/2">
                <table className="w-full text-[0.65rem]">
                  <tbody>
                    <tr>
                      <td className="text-right pr-2 py-1">Subtotal</td>
                      <td className="text-right w-20 py-1">{values?.subtotal?.toFixed(3)}</td>
                    </tr>
                    <tr>
                      <td className="text-right pr-2 py-1">VAT (5%)</td>
                      <td className="text-right py-1">{values?.taxamount?.toFixed(3)}</td>
                    </tr>
                    <tr>
                      <td className="text-right pr-2 py-1">Discount</td>
                      <td className="text-right py-1">
                        {values?.discount_type
                          ? values?.discount_value
                            ? `${values?.discount?.toFixed(3)} (-${values?.discount_value}%)`
                            : "0.000"
                          : values?.discount
                            ? `-${values?.discount?.toFixed(3)}`
                            : "0.000"}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right pr-2 py-1">Delivery Charges</td>
                      <td className="text-right py-1">
                        {values?.delivery?.toFixed(3) || "0.000"}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right pr-2 py-2 font-semibold">Total (OMR)</td>
                      <td className="text-right py-2 font-semibold">{values?.total?.toFixed(3)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>


          <div className="flex justify-between pt-12 text-[0.60rem]">
            <div className="text-center">
              <div className="border-b border-gray-400 w-32 mb-1"></div>
              <div className="text-bold">Received By</div>
            </div>
            <div className="text-center">
              <div className="border-b border-gray-400 w-32 mb-1"></div>
              <div className="text-bold">Checked By</div>
            </div>
            <div className="text-center">
              <div className="border-b border-gray-400 w-32 mb-1"></div>
              <div className="text-bold">Prepared By</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default A4Invoice;